/**
 * Hovering (or focusing) a colour swatch on a product card swaps the card's
 * main image to that colourway's photo, then reverts on mouseleave/blur.
 * Delegated on document since card-product renders many times per page.
 */
(() => {
  function findMainImage(swatchesEl) {
    const card = swatchesEl.closest('.card');
    return card && card.querySelector('[data-card-main-image]');
  }

  function applySwatch(swatchesEl, button) {
    const img = findMainImage(swatchesEl);
    if (!img || !button) return;
    img.src = button.dataset.previewSrc;
    img.srcset = button.dataset.previewSrcset;
  }

  function revertImage(swatchesEl) {
    const img = findMainImage(swatchesEl);
    if (!img) return;
    img.src = img.dataset.originalSrc;
    img.srcset = img.dataset.originalSrcset;
  }

  document.addEventListener(
    'mouseover',
    (event) => {
      const button = event.target.closest('.card__swatch');
      if (!button) return;
      applySwatch(button.closest('[data-card-swatches]'), button);
    },
    true
  );

  document.addEventListener(
    'focus',
    (event) => {
      const button = event.target.closest('.card__swatch');
      if (!button) return;
      applySwatch(button.closest('[data-card-swatches]'), button);
    },
    true
  );

  document.addEventListener(
    'mouseleave',
    (event) => {
      const swatchesEl = event.target.closest && event.target.closest('[data-card-swatches]');
      if (!swatchesEl) return;
      revertImage(swatchesEl);
    },
    true
  );

  document.addEventListener(
    'focusout',
    (event) => {
      const swatchesEl = event.target.closest && event.target.closest('[data-card-swatches]');
      if (!swatchesEl) return;
      if (swatchesEl.contains(event.relatedTarget)) return;
      revertImage(swatchesEl);
    },
    true
  );
})();
